import React from "react";
import PropTypes from "prop-types";
import { CircularProgress } from "@material-ui/core";
import InboxIcon from "@material-ui/icons/Inbox";
import ValidateStatusFlag from "./ValidateStatusFlag";
import { plural } from "./UploadCommon";

const FileFlags = props => {
  const { file } = props;

  const errorCount = file.joiErrors.length + file.errors.length;
  let errorFlag;
  let warningFlag;
  if (file.isValidating) return <CircularProgress />;
  if (file.hasValidated) {
    if (!file.errors.length && !file.warnings.length && !file.joiErrors.length)
      return <ValidateStatusFlag type="ok">Ok</ValidateStatusFlag>;
    if (file.errors.length || file.joiErrors.length) {
      errorFlag = (
        <ValidateStatusFlag type="error">
          {plural(errorCount, "Error")}
        </ValidateStatusFlag>
      );
    }
    if (file.warnings.length) {
      warningFlag = (
        <ValidateStatusFlag type="warning">
          {plural(file.warnings.length, "Warning")}
        </ValidateStatusFlag>
      );
    }

    return (
      <div>
        {warningFlag}
        {errorFlag}
      </div>
    );
  }
  return <InboxIcon />;
};
FileFlags.propTypes = {
  file: PropTypes.shape({
    validationLog: PropTypes.arrayOf(PropTypes.object),
    isValidating: PropTypes.bool,
    hasValidated: PropTypes.bool
  }).isRequired
};
export default FileFlags;
